module.exports = __webpack_public_path__ + "img/Olympique-Lyonnais.42e2071f.png";